/* @flow */
import {edapTriggerPriceSummaryDisplay} from '@homeaway/react-price-summary';
import {trigger as edapTrigger} from './edapWrapper';
import type {
    SERPHitShape as MapHitSERPHitShape,
    ListingShape as MapHitListingShape
} from '../components/MapHit/MapHit';
import type {
    SERPHitShape as HitSERPHitShape,
    ListingShape as HitListingShape
} from '../components/Hit/Hit';
import type {Badge} from '../components/HitInfo/HitInfo';

export const LIST_HIT_CLICK = 'search.hit.click';
export const MAP_HIT_CLICK = 'search.map.hit.click';
export const MAP_MARKER_CLICK = 'search.map.property.click';

type HitEdapEventAction =
    | typeof LIST_HIT_CLICK
    | typeof MAP_HIT_CLICK
    | typeof MAP_MARKER_CLICK;

type SERPHitShape = HitSERPHitShape | MapHitSERPHitShape;
type ListingShape = HitListingShape | MapHitListingShape;

function parseBadges(partnerBadges: ?(Badge[])) {
    let badges;
    if (partnerBadges) {
        badges = partnerBadges.map(({id}) => id);
    }

    return (badges || []).join(',');
}

const triggerHitEdapEvent = (
    hit: SERPHitShape,
    listing: ListingShape,
    eventCategory: HitEdapEventAction,
    delayProcessing?: boolean,
    skipReportPositioning?: boolean,
    skipPriceSummaryTrigger?: boolean
) => {
    const options = {delayProcessing};
    const {listingId, partnerBadges, priceSummary, virtualTourBadge} = listing;
    const badges = [
        parseBadges(partnerBadges),
        virtualTourBadge && 'virtualTourBadge'
    ]
        .filter(Boolean)
        .join(',');

    let data = {
        eventlistingids: listingId,
        badges
    };

    if (!skipReportPositioning) {
        data = {
            ...data,
            absoluteposition: hit.absolutePosition.toString(),
            relativeposition: hit.relativePosition.toString()
        };
    }

    edapTrigger(eventCategory, data, options);

    if (priceSummary && !skipPriceSummaryTrigger) {
        edapTriggerPriceSummaryDisplay(priceSummary, {delayProcessing});
    }
};

export const triggerListHitClickEDAPEvent = (
    hit: HitSERPHitShape,
    listing: HitListingShape
) => {
    triggerHitEdapEvent(hit, listing, LIST_HIT_CLICK, true);
};

export const triggerMapHitClickEDAPEvent = (
    hit: MapHitSERPHitShape,
    listing: MapHitListingShape
) => {
    triggerHitEdapEvent(hit, listing, MAP_HIT_CLICK, true);
};

export const triggerMarkerClickEDAPEvent = (
    hit: MapHitSERPHitShape,
    listing: MapHitListingShape
) => {
    triggerHitEdapEvent(hit, listing, MAP_MARKER_CLICK, false, false, true);
};

export const triggerExpandedSearchGroupHitClickEDAPEvent = (
    hit: HitSERPHitShape,
    listing: HitListingShape
) => {
    triggerHitEdapEvent(hit, listing, LIST_HIT_CLICK, true, true);
};
